const eventViewCouponService = (params, category, type) => {
  if (typeof window !== 'undefined' && params) {
    (window as any)?.dataLayer?.push({
      event: 'productImpression',
      eventCategory: `ecommerce ${type} servis`,
      eventLabel: category === '' ? 'semua' : category,
      ecommerce: {
        currencyCode: 'IDR',
        impressions: params,
      },
    });
  }
};
export default eventViewCouponService;
